const getters = {
  allTickets: (state) => state.ticketList,
  populatedBoards: (state) => state.populatedBoards.data,
  populatedBoardsPending: (state) => state.populatedBoards.status.pending,
};

export default getters;
